import Vue from "vue";
import wrap from "@vue/web-component-wrapper";
import "./services/axios";

// Translation
import VueI18n from "vue-i18n";
Vue.use(VueI18n);

// Buefy Framework
import {
    Button,
    Checkbox,
    Datepicker,
    Dropdown,
    Field,
    Icon,
    Input,
    Message,
    Modal,
    Numberinput,
    Radio,
    Select,
    Tag
} from "buefy";
Vue.use(Button);
Vue.use(Checkbox);
Vue.use(Datepicker);
Vue.use(Dropdown);
Vue.use(Field);
Vue.use(Icon);
Vue.use(Input);
Vue.use(Message);
Vue.use(Modal);
Vue.use(Numberinput);
Vue.use(Radio);
Vue.use(Select);
Vue.use(Tag);

// SHADOW MODE COMPONENTS
const AboutLib = wrap(Vue, () => import(/* webpackChunkName: "AboutLib" */ "./components/AboutLib"));
const Text = wrap(Vue, () => import(/* webpackChunkName: "Text" */ "./components/Text"));
const NewsletterSubscriptionForm = wrap(Vue, () => import(/* webpackChunkName: "NewsletterSubscriptionForm" */ "./components/NewsletterSubscriptionForm"));
const NewPasswordForm = wrap(Vue, () => import(/* webpackChunkName: "NewPasswordForm" */ "./components/NewPasswordForm"));
const ResetPasswordForm = wrap(Vue, () => import(/* webpackChunkName: "ResetPasswordForm" */ "./components/ResetPasswordForm"));
const SignInForm = wrap(Vue, () => import(/* webpackChunkName: "SignInForm" */ "./components/SignInForm"));
const SignUp = wrap(Vue, () => import(/* webpackChunkName: "SignUp" */ "./components/SignUp"));
const AccountIcon = wrap(Vue, () => import(/* webpackChunkName: "AccountIcon" */ "./components/AccountIcon"));
const Account = wrap(Vue, () => import(/* webpackChunkName: "Account" */ "./components/Account"));
const GdprCustomer = wrap(Vue, () => import(/* webpackChunkName: "GdprCustomer" */ "./components/GdprCustomer"));
const GdprCandidate = wrap(Vue, () => import(/* webpackChunkName: "GdprCandidate" */ "./components/GdprCandidate"));
const RecruitmentPostList = wrap(Vue, () => import(/* webpackChunkName: "RecruitmentPostList" */ "./components/RecruitmentPostList"));
const RecruitmentPost = wrap(Vue, () => import(/* webpackChunkName: "RecruitmentPost" */ "./components/RecruitmentPost"));
const RecruitmentPostDomain = wrap(Vue, () => import(/* webpackChunkName: "RecruitmentPostDomain" */ "./components/RecruitmentPostDomain"));
const ProductTree = wrap(Vue, () => import(/* webpackChunkName: "ProductTree" */ "./components/ProductTree"));
const ActivityCalendar = wrap(Vue, () => import(/* webpackChunkName: "ActivityCalendar" */ "./components/ActivityCalendar"));
const ActivityProductPrice = wrap(Vue, () => import(/* webpackChunkName: "ActivityProductPrice" */ "./components/ActivityProductPrice"));
const LessonCalendar = wrap(Vue, () => import(/* webpackChunkName: "LessonCalendar" */ "./components/LessonCalendar"));
const UseTicketingBarcode = wrap(Vue, () => import(/* webpackChunkName: "UseTicketingBarcode" */ "./components/UseTicketingBarcode"));
const LessonPrice = wrap(Vue, () => import(/* webpackChunkName: "LessonPrice" */ "./components/LessonPrice"));
const StagesPlanner = wrap(Vue, () => import(/* webpackChunkName: "StagesPlanner" */ "./components/StagesPlanner"));
const PrivateLessonPrice = wrap(Vue, () => import(/* webpackChunkName: "PrivateLessonPrice" */ "./components/PrivateLessonPrice"));
const SubscriptionPrice = wrap(Vue, () => import(/* webpackChunkName: "SubscriptionPrice" */ "./components/SubscriptionPrice"));
const StagePrice = wrap(Vue, () => import(/* webpackChunkName: "StagePrice" */ "./components/StagePrice"));
const UnlimitedSubscriptionPrice = wrap(Vue, () => import(/* webpackChunkName: "UnlimitedSubscriptionPrice" */ "./components/UnlimitedSubscriptionPrice"));
const MultiTicketsBookPrice = wrap(Vue, () => import(/* webpackChunkName: "MultiTicketsBookPrice" */ "./components/MultiTicketsBookPrice"));
const TicketsBookPrice = wrap(Vue, () => import(/* webpackChunkName: "TicketsBookPrice" */ "./components/TicketsBookPrice"));
const ProductPrice = wrap(Vue, () => import(/* webpackChunkName: "ProductPrice" */ "./components/ProductPrice"));
const UnlimitedSubscriptionCartBtn = wrap(Vue, () => import(/* webpackChunkName: "UnlimitedSubscriptionCartBtn" */ "./components/UnlimitedSubscriptionCartBtn"));
const Pack = wrap(Vue, () => import(/* webpackChunkName: "Pack" */ "./components/Pack"));

const BasketIcon = wrap(Vue, () => import(/* webpackChunkName: "BasketIcon" */ "./components/BasketIcon"));
const CartProduct = wrap(Vue, () => import(/* webpackChunkName: "CartProduct" */ "./components/CartProduct"));
const CartCustomer = wrap(Vue, () => import(/* webpackChunkName: "CartCustomer" */ "./components/CartCustomer"));
const CartPayment = wrap(Vue, () => import(/* webpackChunkName: "CartPayment" */ "./components/CartPayment"));

window.customElements.define("osv-about-lib", AboutLib);
window.customElements.define("osv-text", Text);
window.customElements.define("osv-newsletter-subscription-form", NewsletterSubscriptionForm);
window.customElements.define("osv-new-password", NewPasswordForm);
window.customElements.define("osv-reset-password", ResetPasswordForm);
window.customElements.define("osv-sign-in", SignInForm);
window.customElements.define("osv-sign-up", SignUp);
window.customElements.define("osv-account-icon", AccountIcon);
window.customElements.define("osv-account", Account);
window.customElements.define("osv-gdpr-customer", GdprCustomer);
window.customElements.define("osv-gdpr-candidate", GdprCandidate);
window.customElements.define("osv-recruitment-post-list", RecruitmentPostList);
window.customElements.define("osv-recruitment-post", RecruitmentPost);
window.customElements.define("osv-recruitment-post-domain", RecruitmentPostDomain);
window.customElements.define("osv-product-tree", ProductTree);
window.customElements.define("osv-activity-calendar", ActivityCalendar);
window.customElements.define("osv-activity-product-price", ActivityProductPrice);
window.customElements.define("osv-lesson-calendar", LessonCalendar);
window.customElements.define("osv-use-ticketing-barcode", UseTicketingBarcode);
window.customElements.define("osv-lesson-price", LessonPrice);
window.customElements.define("osv-stages-planner", StagesPlanner);
window.customElements.define("osv-private-lesson-price", PrivateLessonPrice);
window.customElements.define("osv-stage-price", StagePrice);
window.customElements.define("osv-subscription-price", SubscriptionPrice);
window.customElements.define("osv-unlimited-subscription-price", UnlimitedSubscriptionPrice);
window.customElements.define("osv-multi-tickets-book-price", MultiTicketsBookPrice);
window.customElements.define("osv-tickets-book-price", TicketsBookPrice);
window.customElements.define("osv-product-price", ProductPrice);
window.customElements.define("osv-basket-icon", BasketIcon);
window.customElements.define("osv-add-to-cart-unlimited-subscription-btn", UnlimitedSubscriptionCartBtn);
window.customElements.define("osv-cart-product", CartProduct);
window.customElements.define("osv-cart-customer", CartCustomer);
window.customElements.define("osv-cart-payment", CartPayment);
window.customElements.define("osv-pack", Pack);

// NO SHADOW MODE COMPONENTS
import vueCustomElement from "vue-custom-element";
import { getProps } from 'vue-custom-element/src/utils/props'
Vue.use(vueCustomElement);

const asyncCustomEl = (component) => () => new Promise((resolve) => {
    setTimeout(() => {
        resolve(component)
    }, 0)
})

import IfConnected from "./components/IfConnected";
import IfNotConnected from "./components/IfNotConnected";

Vue.customElement("osv-if-connected", asyncCustomEl(IfConnected), { props: getProps(IfConnected).camelCase });
Vue.customElement("osv-if-not-connected", asyncCustomEl(IfNotConnected), { props: getProps(IfNotConnected).camelCase });

// Import material design icons stylesheet
const materialDesignIcons = document.createElement('link');
materialDesignIcons.href = `https://cdn.materialdesignicons.com/5.3.45/css/materialdesignicons.min.css`;
materialDesignIcons.rel = 'stylesheet';
materialDesignIcons.id = 'osv-material-design-icon-stylesheet';
document.head.appendChild(materialDesignIcons);
